import { useEffect, useState } from 'react'
import type { FilterFacetKey } from '../RegistryFilters.static'

export interface SelectedFilterValues {
  readonly hub: string
  readonly businessObject: string
}

export interface UseRegistryFiltersDialogOptions {
  readonly isOpen: boolean
  readonly selectedValues: SelectedFilterValues
  readonly onApply: (values: SelectedFilterValues) => void
  readonly onClose: () => void
}

export function useRegistryFiltersDialog({
  isOpen,
  selectedValues,
  onApply,
  onClose,
}: UseRegistryFiltersDialogOptions) {
  const [staged, setStaged] = useState<SelectedFilterValues>(selectedValues)
  const [focusFacetKey, setFocusFacetKey] = useState<FilterFacetKey | null>(null)

  // Re-seed from the currently applied filters (and go back to the facet menu) each time the
  // dialog is (re)opened, discarding whatever was staged (but not applied) last time.
  useEffect(() => {
    if (isOpen) {
      setStaged(selectedValues)
      setFocusFacetKey(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const hasChanges = staged.hub !== selectedValues.hub || staged.businessObject !== selectedValues.businessObject

  function selectFacetValue(key: FilterFacetKey, value: string) {
    setStaged((current) => ({ ...current, [key]: value }))
  }

  function applyAndClose() {
    onApply(staged)
    onClose()
  }

  return { staged, focusFacetKey, setFocusFacetKey, hasChanges, selectFacetValue, applyAndClose, cancelAndClose: onClose }
}
